"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Fab_1 = __importDefault(require("@material-ui/core/Fab"));
var Fab = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.component, component = _b === void 0 ? 'button' : _b, _c = _a.color, color = _c === void 0 ? 'default' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.disableFocusRipple, disableFocusRipple = _e === void 0 ? false : _e, disableRipple = _a.disableRipple, href = _a.href, _f = _a.size, size = _f === void 0 ? 'large' : _f, _g = _a.variant, variant = _g === void 0 ? 'round' : _g;
    return (react_1.default.createElement(Fab_1.default, { classes: classes, component: component, color: color, disabled: disabled, disableFocusRipple: disableFocusRipple, disableRipple: disableRipple, href: href, size: size, variant: variant }, children));
};
exports.default = Fab;
